import { trackByIndex } from 'src/app/shared/utils/track-by.util';
import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { Sort } from '@angular/material/sort';

import { CommonService } from 'src/app/services/common.service';
import { ExposureBySEGs } from 'src/app/models/exposureBySeg.model';
import { ErrorConstants } from 'src/app/shared/constants/error.constants';

@Component({
  standalone: false,
  selector: 'app-exposure-by-segs-popup',
  templateUrl: './exposure-by-segs-popup.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./exposure-by-segs-popup.component.scss']
})
export class ExposureBySegsPopupComponent implements OnInit {
  @Input() exposureBySEGsAll: ExposureBySEGs[];
  @Input() loading: boolean = true;
  @Input() showAllPopup: boolean = false;

  @Input() segAllSort: string = "change";
  @Input() segAllOrder: string = "desc";

  @Output() sortAllSEGEmit = new EventEmitter<Sort>();
  @Output() showSEGDetailEmit = new EventEmitter<ExposureBySEGs>();
  @Output() hideAllPopupEmit = new EventEmitter<any>();

  errorMessage = "";
  colors: any = this.commonService.colors;

  constructor(
    private commonService: CommonService,
  ) {
    this.errorMessage = ErrorConstants.errorMessage;
  }

  ngOnInit(): void {
  }

  showChangeAlert(seg) {
    if(seg.previousRiskCategory && seg.riskCategory) {
      if(
        (seg.previousRiskCategory == 'Low' && ['Medium', 'High', 'Ultra-High'].includes(seg.riskCategory)) ||
        (seg.previousRiskCategory == 'Medium' && ['High', 'Ultra-High'].includes(seg.riskCategory)) ||
        (seg.previousRiskCategory == 'High' && ['Ultra-High'].includes(seg.riskCategory))
        ) {
          return true;
      }
    }
    return false;
  }

  changeAbs(val) {
    return Math.abs(val);
  }

  hideAllPopupFn(event) {
    this.hideAllPopupEmit.emit(event);
  }

  showSEGDetailFn(seg: ExposureBySEGs) {
    this.showSEGDetailEmit.emit(seg)
  }

  sortAllSEG(sort: Sort) {
    this.sortAllSEGEmit.emit(sort);
  }

  public trackByIndex = trackByIndex;
}
